import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initApm } from "@/shared/utils/apm";
import { App } from "@/admin/app/App";

initApm({
  serverUrl: import.meta.env.VITE_ADMIN_ELASTIC_APM_SERVER_URL,
  serviceName: import.meta.env.VITE_ADMIN_ELASTIC_APM_SERVICE_NAME,
});

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
